import {Container, Row, Button, Col} from "react-bootstrap";
import {useState} from "react";

import axios from "axios";
import Product from "../component/Product";
import Title from "../component/title";
import Title2 from "../component/Title2";
import nike from "../nike.js";

function Home(props) {
  let [count, setCount] = useState(1);
  //   let [res, setRes] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8]);
  let [nike1, setNike1] = useState(nike);
  return (
    <>
      <div className="slider"></div>
      <Title />
      {/* 정렬 버튼 */}
      <div style={{marginBottom: "10px"}}>
        <Button
          variant="success"
          onClick={() => {
            let copy = [...props.shoes].sort((a, b) => (a.title > b.title ? 1 : -1));
            props.setShoes(copy);

            let res1 = [];
            for (let i in copy) {
              res1.push(copy[i].id);
            }
            props.setRes(res1);
          }}
        >
          이름순 정렬
        </Button>{" "}
        <Button
          variant="warning"
          onClick={() => {
            let copy = [...props.shoes].sort((a, b) => (a.price > b.price ? 1 : -1));
            props.setShoes(copy);

            let res1 = [];
            for (let i in copy) {
              res1.push(copy[i].id);
            }
            props.setRes(res1);
          }}
        >
          낮은가격순 정렬
        </Button>{" "}
        <Button
          variant="info"
          onClick={() => {
            let copy = [...props.shoes].sort((a, b) => (a.price < b.price ? 1 : -1));
            props.setShoes(copy);

            let res1 = [];
            for (let i in copy) {
              res1.push(copy[i].id);
            }
            props.setRes(res1);
          }}
        >
          높은가격순 정렬
        </Button>
      </div>
      {/* 아이템 9개 */}
      <Container>
        <Row>
          {props.shoes.map((v, i) => {
            return <Product shoes={props.shoes[i]} i={i} res={props.res} setRes={props.setRes} />;
          })}
        </Row>
      </Container>
      <Title2 />
      <Button
        variant="outline-success"
        style={{marginBottom: "10px"}}
        onClick={() => {
          if (count === 1) {
            axios.get("https://raw.githubusercontent.com/Nubeez/nike_item/main/nike2.json").then((result) => {
              let copy = [...nike1, ...result.data];
              console.log(result);
              setNike1(copy);
              setCount(2);
            });
          } else if (count === 2) {
            axios.get("https://raw.githubusercontent.com/Nubeez/nike_item/main/nike3.json").then((result) => {
              let copy = [...nike1, ...result.data];
              setNike1(copy);
              setCount(3);
            });
          } else {
            alert("더이상 상품이 없습니다.");
          }
        }}
      >
        +3개 상품 더보기
      </Button>{" "}
      <br />
      <Container>
        <Row>
          {nike1.map((ele, i) => {
            return <Nike nike1={nike1[i]} />;
          })}
        </Row>
      </Container>
    </>
  );
}
function Nike(props) {
  return (
    <Col md={4}>
      <img alt="item2" src={props.nike1.imgUrl} width="80%" />
      <h5>{props.nike1.title}</h5>
      <p>{props.nike1.content}</p>
      <p>{props.nike1.price}</p>
    </Col>
  );
}
export default Home;
